import dayjs from "dayjs";
import {EntityBase} from "../../../shared/entity/EntityBase";

const TROPHY_CHALLENGE_FIELDS = {
    trophyId: {type: Number, defaultValue: 0},
    memo: {defaultValue: ''},
    openLevel: {type: Number, defaultValue: 100},
    challengeGroupIdx: {type: Number, defaultValue: 0},
    missionGroupIdx: {type: Number, defaultValue: 0},
    clearCount: {type: Number, defaultValue: 0},
    onOff: {type: Number, defaultValue: 0},
    begin: {type: Number, defaultValue: dayjs().hour(0).startOf('hour').unix()},
    end: {type: Number, defaultValue: dayjs().add(30, 'day').hour(23).endOf('hour').unix()},
}

export class TrophyChallengeEntity extends EntityBase {
    constructor(data = {}) {
        super(data, TROPHY_CHALLENGE_FIELDS);

        this.errors = [
            {condition: () => this.challengeGroupIdx === 0, message: '챌린지 그룹을 선택해주세요.'},
            {condition: () => this.missionGroupIdx === 0, message: '챌린지 미션을 선택해주세요.'},
            {condition: () => this.clearCount <= 0, message: '완료 조건(트로피 개수)을 입력해주세요.'},
            {condition: () => this.begin > this.end, message: '시작일이 종료일보다 늦습니다.'},
        ];
    }
}
